import { createContext, FC, ReactNode } from 'react';

export type ICreateBranchPartnerContext = {
  id?: string;
  onSucceed: () => void;
  onCancel: () => void;
};

const defaultValues: ICreateBranchPartnerContext = {
  onSucceed: () => {},
  onCancel: () => {},
};

export const CreateBranchPartnerContext = createContext<ICreateBranchPartnerContext>(defaultValues);

export const CreateBranchPartnerProvider: FC<Partial<ICreateBranchPartnerContext> & { children?: ReactNode }> = ({
  children,
  id,
  onSucceed = defaultValues.onSucceed,
  onCancel = defaultValues.onCancel,
}) => {
  return <CreateBranchPartnerContext.Provider value={{ id, onSucceed, onCancel }}>{children}</CreateBranchPartnerContext.Provider>;
};
